var resources = require('itemsViewStrings');
    var strings = resources['_c+M/anMK1d6vPr2xIabP8Q'];
export { strings };
export default strings;
